import React, { PropsWithChildren } from 'react';
import View from 'styleguide/View/View';
import style from './PaddingContainer.module.scss';

export default function PaddingContainer(props: PropsWithChildren<Record<string, unknown>>) {
	return <View className={style.PaddingContainer}>{props.children}</View>;
}
